import { render, staticRenderFns } from "./ListaObservacoes.vue?vue&type=template&id=22a18b18&"
import script from "./ListaObservacoes.vue?vue&type=script&lang=js&"
export * from "./ListaObservacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports